import Controller from '@ember/controller';
import {
  action,
  computed,
  get,
  getProperties,
  set,
  setProperties,
} from '@ember/object';
import { filterBy, sort } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { eventTypeNames } from 'donor-elf-web/lib/event-type-names';
import { task } from 'ember-concurrency';

export default Controller.extend({
  currentUser: service(),
  fundsService: service(),
  store: service(),

  eventTypeNames: computed(function () {
    let names = { ...eventTypeNames };
    // don't show Donor Info Changed event
    delete names[4];
    return names;
  }),

  sortFundsBy: ['fund.name'],
  sortedFundItems: sort('model.allFundItems', 'sortFundsBy'),
  filteredFundItems: computed('sortedFundItems.[]', 'fundsQuery', function () {
    let { sortedFundItems, fundsQuery } = getProperties(
      this,
      'sortedFundItems',
      'fundsQuery',
    );
    let scrubbedFundsQuery = (fundsQuery || '').toLowerCase().trim();
    if (isEmpty(scrubbedFundsQuery)) {
      return sortedFundItems;
    }
    return sortedFundItems.filter((fundItem) => {
      return (
        get(fundItem, 'fund.nameLowerCase').indexOf(scrubbedFundsQuery) >= 0
      );
    });
  }),
  selectedFundItems: filterBy('sortedFundItems', 'isSelected', true),

  error: null,
  saveComplete: false,
  showValidationErrors: false,
  fundsQuery: '',

  reset() {
    setProperties(this, {
      error: null,
      saveComplete: false,
      showValidationErrors: false,
      fundsQuery: '',
    });
  },

  save: task(function* () {
    try {
      yield this.fundsService.confirmValidFundToken();
      let changeset = get(this, 'model.changeset');
      set(
        changeset,
        'fundIds',
        this.selectedFundItems.map((item) => {
          return get(item, 'fund.id');
        }),
      );
      set(changeset, 'emailTo', get(changeset, 'emailToString').split(','));
      yield changeset.validate();
      set(this, 'showValidationErrors', true);
      if (get(changeset, 'isValid')) {
        let excludeEventTypeIds = [];
        for (let eventTypeId in eventTypeNames) {
          if (
            get(this, `model.selectedEventsChangeset.${eventTypeId}`) === false
          ) {
            excludeEventTypeIds.push(+eventTypeId);
          }
        }
        set(changeset, 'excludeEventTypeIds', excludeEventTypeIds);
        yield changeset.save();
        this.send('refreshNotifications');
        set(this, 'saveComplete', true);
      }
    } catch (error) {
      set(this, 'error', error);
    }
  }).drop(),

  applyFilter: action(function (fundsQuery) {
    console.log('applyFilter', fundsQuery);
    set(this, 'fundsQuery', fundsQuery);
  }),
});
